import { Injectable, Optional, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceRouter } from '@pershing/pershing-core';
import { ContentManagementServiceDefinition } from './content-management-service-definition';

@Injectable()
export class ContentStudioService {

    baseUrl = '';
    getContentURL = '';
    writeContentURL = '';
    siteUrl: string;
    stagingSiteUrl: string;

    constructor(private http: HttpClient, private serviceRouter: ServiceRouter, @Optional() @Inject('AppSettings') private appSettings: any) {
        // this.baseUrl = 'http://localhost:8080/webcontent/SBcms';
        // this.baseUrl = 'https://nonprod10-cluster.bnymellon.net/dev-netxinvestor-webcontent-svc-dev-app/webcontent';
        this.baseUrl = this.serviceRouter.getServiceRouteURL(ContentManagementServiceDefinition.getInstance(), { ignoreOptions: { serviceVersion: true } });
    }

    getContent(siteId: string, stagingSiteId: string, contentName: string, contentPath: string, contentHierarchy: string[], isStaging: boolean, isComingFromCreatedSite: boolean): Observable<any> {
        let getUrl: string = `${this.baseUrl}/textContent/${siteId}/${stagingSiteId}/${contentName}?isStaging=${isStaging}&isComingFromCreatedSite=${isComingFromCreatedSite}&contentPath=${contentPath}`;
        if (contentHierarchy && contentHierarchy.length > 0) {
            getUrl += `&hierarchy=${contentHierarchy.join(',')}`;
        }
        return this.http.get(getUrl);
    }

    writeContent(siteId: string, stagingSiteId: string, contentName: string, contentPath: string, stagingContentPath: string, contentTitle: string, contentText: string, userId: string): Observable<any> {
        this.writeContentURL = `${this.baseUrl}/write/textContent/${siteId}/${stagingSiteId}?contentPath=${contentPath}&stagingContentPath=${stagingContentPath}&user=${userId}`;
        let writeBody: any = {
            articleID: contentName,
            title: contentTitle,
            content: contentText
        };
        return this.http.post(this.writeContentURL, writeBody);
    }

    getImageContent(siteId: string, stagingSiteId: string, contentName: string, contentPath: string, contentHierarchy: string[], isStaging: boolean, isComingFromCreatedSite: boolean): Observable<any> {
        let getUrl: string = `${this.baseUrl}/imageContent/${siteId}/${stagingSiteId}?contentName=${contentName}&isStaging=${isStaging}&isComingFromCreatedSite=${isComingFromCreatedSite}&contentPath=${contentPath}`;
        if (contentHierarchy && contentHierarchy.length > 0) {
            getUrl += `&hierarchy=${contentHierarchy.join(',')}`;
        }
        return this.http.get(getUrl);
    }

    writeImageContent(siteId: string, stagingSiteId: string, contentPath: string, stagingContentPath: string, contentName: string, file: File, userId: string): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('contentPath', contentPath);
        formData.append('stagingContentPath', stagingContentPath);
        formData.append('contentName', contentName);
        formData.append('user', userId);
        this.writeContentURL = `${this.baseUrl}/write/imageContent/${siteId}/${stagingSiteId}`;
        return this.http.post(this.writeContentURL, formData);
    }

    deleteContent(siteId: string, contentName: string, contentPath: string, isStaticImage: boolean): Observable<any> {
        this.getContentURL = this.baseUrl + '/deleteContent/' + siteId + '?' +
            'contentName=' + contentName +
            '&contentPath=' + contentPath +
            '&isStaticImage=' + isStaticImage;
        return this.http.get(this.getContentURL);
    }
}
